export const CONNECTOR_OAUTH_STATUS = {
	IDLE: 'idle',
	CONNECTING: 'connecting',
	CONNECTED: 'connected',
	ERROR: 'error',
} as const;

export type ConnectorOAuthStatus =
	(typeof CONNECTOR_OAUTH_STATUS)[keyof typeof CONNECTOR_OAUTH_STATUS];

export const CONNECTOR_OAUTH_ERROR_SUBTYPE = {
	POPUP_BLOCKED: 'popup-blocked',
	GENERIC: 'generic',
} as const;

export type ConnectorOAuthErrorSubtype =
	(typeof CONNECTOR_OAUTH_ERROR_SUBTYPE)[keyof typeof CONNECTOR_OAUTH_ERROR_SUBTYPE];

export const CONNECTOR_OAUTH_ABORT_REASON = {
	POPUP_BLOCKED: 'popup-blocked',
	UNMOUNTED_DURING_OAUTH: 'unmounted-during-oauth',
	RESOLVED_AFTER_UNMOUNT: 'resolved-after-unmount',
} as const;

export type ConnectorOAuthAbortReason =
	(typeof CONNECTOR_OAUTH_ABORT_REASON)[keyof typeof CONNECTOR_OAUTH_ABORT_REASON];

export const CONNECTOR_OAUTH_CANCELLATION_REASON = {
	USER_CLOSED_WINDOW: 'user-closed-window',
} as const;

export type ConnectorOAuthCancellationReason =
	(typeof CONNECTOR_OAUTH_CANCELLATION_REASON)[keyof typeof CONNECTOR_OAUTH_CANCELLATION_REASON];

export type ConnectorOAuthIdentity = {
	productKey: string;
	resourceType?: string;
};

export type ConnectorOAuthConfig = ConnectorOAuthIdentity & {
	outboundAuthUrl?: string;
	userNeedsOAuth?: boolean;
};

export type ConnectorOAuthLifecycleEvent =
	| {
			type: 'auth-started';
	  }
	| {
			type: 'auth-aborted';
			reason: ConnectorOAuthAbortReason;
	  }
	| {
			type: 'auth-cancelled';
			reason: ConnectorOAuthCancellationReason;
	  }
	| {
			type: 'auth-error-observed';
			error: Error;
	  }
	| {
			type: 'auth-failed';
			durationMs: number;
			error: Error;
			errorSubtype: ConnectorOAuthErrorSubtype;
	  }
	| {
			type: 'auth-succeeded';
			durationMs: number;
	  }
	| {
			type: 'cache-update-failed';
			error: Error;
	  };

export type ConnectorOAuthLifecycleCallback = (
	event: ConnectorOAuthLifecycleEvent,
	connector: ConnectorOAuthIdentity,
) => void;

export type UseConnectorOAuthOptions = {
	connector: ConnectorOAuthConfig;
	cloudId?: string;
	userId?: string | null;
	onLifecycleEvent?: ConnectorOAuthLifecycleCallback;
};

export type UseConnectorOAuthResult = {
	status: ConnectorOAuthStatus;
	errorSubtype: ConnectorOAuthErrorSubtype | null;
	remountKey: number;
	connect: () => Promise<void>;
};
